var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonVegIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 17,
    height: 17,
    stroke: "#C72438"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13397 6C8.51887 5.33333 9.48113 5.33333 9.86603 6L13.3301 12C13.715 12.6667 13.2339 13.5 12.4641 13.5H5.5359C4.7661 13.5 4.28497 12.6667 4.66987 12L8.13397 6Z",
    fill: "#C72438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonVegIcon);
export default __webpack_public_path__ + "static/media/nonVegIcon.9456d9a4266414dc3571ea695b19c38f.svg";
export { ForwardRef as ReactComponent };